
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from "vuex-class";
import moment from 'moment';

import "@/store/modules/forms/form1";
const form1State = namespace("Form1");

import Form1Layout from "./Form1Layout.vue";
import { form1DataInfoType } from '@/types/Information/Form1';


@Component({
    components:{        
        Form1Layout
    }
})
export default class Form1 extends Vue {    
    
    @form1State.State
    public currentNoticeOfAppealId: string;  

    @form1State.Action
    public UpdateForm1Info!: (newForm1Info: form1DataInfoType) => void

    result = {} as form1DataInfoType;
    dataReady = false;

    manualNTrib = false
    manualTrib = false
    manualNorm = false
    normalForm = false

    printReady = false;
   
    mounted(){
        this.dataReady = false;
        this.printReady = false;
        this.getForm1Data(); 
    }   
           
    public onPrint() { 
        const pdf_type = "FORM"
        const pdf_name = "form1-" + this.currentNoticeOfAppealId;
        const el= document.getElementById("print");

        const bottomLeftText = `"COURT OF APPEAL FOR BRITISH COLUMBIA                    www.bccourts.ca/Court_of_Appeal/"`;
        const bottomRightText = `" "`;
        //const bottomLeftText = `"Form 1 (`+moment().format("MMM DD, YYYY")+`)"`;
        //const bottomRightText = `" "`;        
        const url = '/form1/form-print/'+this.currentNoticeOfAppealId+'/?name=' + pdf_name + '&pdf_type='+pdf_type+'&version=1.0&noDownload=true'
        const pdfhtml = Vue.filter('printPdf')(el.innerHTML, bottomLeftText, bottomRightText );

        const body = {
            'html':pdfhtml,
            'json_data':this.result
        }       
        
        const options = {
            responseType: "blob",
            headers: {
            "Content-Type": "application/json",
            }
        }  

        this.$http.post(url,body, options)
        .then(res => {                       
            this.printReady = true; 
            this.$emit('pdfReady')
        },err => {
            console.error(err);        
        });
    }

    public savePdf(){        
        const pdfType = "FORM"
        const pdfName ="FORM1"
        const url = '/form1/form-print/'+this.currentNoticeOfAppealId+'/?pdf_type='+pdfType
        const options = {
            responseType: "blob",
            headers: {
            "Content-Type": "application/json",
            }
        }
        this.$http.get(url, options)
        .then(res => {
            const blob = res.data;
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            document.body.appendChild(link);
            link.download = pdfName+".pdf";
            link.click();
            setTimeout(() => URL.revokeObjectURL(link.href), 1000);          

        },err => {
            console.error(err);
        });
    }

    public navigateToEditPage() {        
        this.$router.push({name: "start-form1"});
    }

    public navigateToSubmitPage(){
        this.$emit('navigateToSubmitPage')
    }

    public determineFormType(form1Info: form1DataInfoType){          
        this.manualNTrib = form1Info.appealingScFlaDivorce || form1Info.insideTimeLimit         
        this.manualTrib = form1Info.appealTribunal
        this.manualNorm = form1Info.requiresManualEntry
        this.normalForm = !this.manualNTrib && !this.manualTrib && !this.manualNorm
    }
 
    public getForm1Data() {        
       
        this.$http.get('/form1/forms/'+this.currentNoticeOfAppealId)
        .then((response) => {
            if(response?.data?.data){            
                            
                this.result = response.data.data
                this.determineFormType(this.result)
                this.result.completionDate = Vue.filter('beautify-date-dd/mm/yyyy')(response.data.modified);
                this.UpdateForm1Info(this.result)                         
                this.dataReady = true;
                Vue.nextTick(()=> this.onPrint())
            }
                
        },(err) => {
        console.log(err)        
        });      
       
    }

    // public onPrintSave() { 
    //     const pdf_type = "FORM"
    //     const pdf_name = "form1-" + this.currentNoticeOfAppealId
    //     const el= document.getElementById("print");
      
    //     const bottomLeftText = `"COURT OF APPEAL FOR BRITISH COLUMBIA                    www.bccourts.ca/Court_of_Appeal/"`;
    //     const bottomRightText = `" "`;        
    //     const url = '/form1/form-print/'+this.currentNoticeOfAppealId+'/?name=' + pdf_name + '&pdf_type='+pdf_type+'&version=1.0'
    //     const pdfhtml = Vue.filter('printPdf')(el.innerHTML, bottomLeftText, bottomRightText );

    //     const body = {
    //         'html':pdfhtml,
    //         'json_data':this.result
    //     }       
        
    //     const options = {
    //         responseType: "blob",
    //         headers: {
    //         "Content-Type": "application/json",
    //         }
    //     }  

    //     this.$http.post(url,body, options)
    //     .then(res => {                       
    //         const blob = res.data;
    //         const link = document.createElement("a");
    //         link.href = URL.createObjectURL(blob);
    //         document.body.appendChild(link);
    //         link.download = "FORM1.pdf";
    //         link.click();
    //         setTimeout(() => URL.revokeObjectURL(link.href), 1000); 
    //     },err => {
    //         console.error(err);        
    //     });
    // }
}
